import * as THREE from "three";
import { Sprite } from "three";
import { Subject } from "rxjs";
import { CollisionPlane } from "./CollisionPlane";
import { Position } from "./Base";
import CharacterAnimations from "./Constants/CharacterAnimations";
import Direction from "./Enums/Direction";
import NpcType from "./Enums/NpcType";
import ZPosition from "./Enums/ZPosition";

export class Npc {
  sprite: Sprite;
  collision: CollisionPlane;
  interactionIndicator: Sprite;

  constructor(npcDto: NpcDto, unsubscribeNotifier$: Subject<void>) {
    npcDto.direction = npcDto.direction ?? Direction.Down;
    npcDto.isInteractable = npcDto.isInteractable ?? false;
    npcDto.zPosition = npcDto.zPosition ?? ZPosition.Npc;

    const texture = new THREE.TextureLoader().load(`./assets/characters/npc/${npcDto.npcType}.png`);
    texture.repeat.set(1 / CharacterAnimations.MovementIndexes, 1);
    texture.magFilter = THREE.NearestFilter;

    this.sprite = new THREE.Sprite();
    this.sprite.scale.set(1, 2, 1);
    this.sprite.position.set(npcDto.x, npcDto.y, npcDto.zPosition);
    this.sprite.material.map = texture;

    this.collision = new CollisionPlane({ x: npcDto.x, y: npcDto.y, width: 1, height: .5, isInteractable: npcDto.isInteractable, yOffset: -.75 });

    const indicatorBaseY = npcDto.y + .75;
    const indicatorTexture = new THREE.TextureLoader().load('./assets/characters/interactions/speach_bubble.png');
    indicatorTexture.magFilter = THREE.NearestFilter;
    this.interactionIndicator = new THREE.Sprite(new THREE.SpriteMaterial({ map: indicatorTexture }));
    this.interactionIndicator.scale.set(.9, .9, .9);
    this.interactionIndicator.position.set(npcDto.x + .5, indicatorBaseY, ZPosition.DynamicObjectAbove);
    this.interactionIndicator.visible = false;
    this.collision.mesh.userData.interactionIndicator = this.interactionIndicator;

    
    let bobCounter = 0;
    const bobInterval = setInterval(() => {
      this.interactionIndicator.position.setY(indicatorBaseY + Math.sin(bobCounter) * 0.08);
      bobCounter += 0.09;
    }, 16);

    let tileIndexes: number[];
    switch (npcDto.direction) {
      case Direction.Up:
        tileIndexes = CharacterAnimations.IdlingCycles.Up;
        break;
      case Direction.Down:
        tileIndexes = CharacterAnimations.IdlingCycles.Down;
        break;
      case Direction.Left:
        tileIndexes = CharacterAnimations.IdlingCycles.Left;
        break;
      case Direction.Right:
        tileIndexes = CharacterAnimations.IdlingCycles.Right;
        break;
    }

    let counter = 0;
    const idleInterval = setInterval(() => {
      texture.offset.setX(tileIndexes[counter] / CharacterAnimations.MovementIndexes);

      ++counter;
      if (counter >= tileIndexes.length) {
        counter = 0;
      }
    }, Math.floor(Math.random() * (300 - 250)) + 250);

    unsubscribeNotifier$.subscribe(() => {
      clearInterval(idleInterval);
      clearInterval(bobInterval);
    });
  }
}

export interface NpcDto extends Position {
  npcType: NpcType;
  isInteractable?: boolean;
  direction?: Direction;
  zPosition?: ZPosition;
}
